import type { BidCollection } from '@/utils/bids'

/**
 * Quick-view payload for an inscription on the bids page. The collection slug
 * lets the modal resolve the item's live listing (and so its Buy button).
 */
export function quickViewPayload(id: string, collection: BidCollection) {
	return { id, inscription: { id, collection: { slug: collection.slug, name: collection.name } } }
}
